import React, { useReducer, useEffect, useState } from "react"
import { getCountryCallingCode } from "react-phone-number-input"
import Layout from "../../../components/layout/layout"
import HowItWorks from "../../../components/cards/howitworks/HowItWorks"
import OurSolutions from "../../../components/solutions/Solutions"
import Clients from "../../../components/cards/clients"
import TestimonialSection from "../../../components/homepage/testimonials"
import Features from "../../../components/cards/features/Features"
import InquireSection from "../../../components/cards/inquire/InquireSection"
import OtherProducts from "../../../components/cards/relatedarticles/RelatedArticles"
import banner from "./banner.png"
import feature1 from "./feature-1.svg"
import feature2 from "./feature-2.svg"
import feature3 from "./feature-3.svg"
import {
  otherProducts,
  productFaq,
  formatNumber,
  validateEmail,
} from "../../../utils"
import SEO from "../../../components/seo"
import { requestService } from "../../../services"
import SucessModal from "../../../components/modals/successModal/successModal"
import BookingSection from "../../../components/serviceCards/bookingSection/index.jsx"

const DashX = ({ location: { pathname } }) => {
  const [details, setDetails] = useReducer(
    (state, newState) => ({
      ...state,
      ...newState,
    }),
    {
      phone: "",
      name: "",
      email: "",
      company: "",
      comments: "",
      designation: "",
      country_code: "+1",
      requesting: false,
      response: "",
      terms: false,
      submitted: false,
    }
  )
  const [showSuccessModal, setShowSuccessModal] = useState(false)
  useEffect(() => {
    let timeout
    if (details.response) {
      setShowSuccessModal(true)
      timeout = setTimeout(() => {
        setShowSuccessModal(false)
        setDetails({ response: "" })
      }, 5000)
    }
    return () => {
      clearTimeout(timeout)
    }
  }, [details.response])
  const data = {
    title:
      "AI & human instincts go \nbetter together with Wersel’s \nDashX solution",
    bannerImage: banner,
    desc:
      "Make better-informed & prompt decisions to deliver an exemplary \ncustomer experience ",
    overview: "DashX Overview",
    overviewText:
      "Wersel’s DashX is a next-gen BI and visualization tool that can de-clutter the noise around data and help extract invaluable insights to speed up decision making. Our AI and human intuition dashboard turns data into live visualizations and real-time metrics. The solution can be integrated via a plug-and-play mode to be instantly available on any device and power decision-making at every level across the organization.\n Making data-driven decisions is now simplified. Business decision makers and C-level executives need not spend time deciphering the data and can have immediate access to key takeaways instead. ",
    features: [
      {
        title: "100% customization \npossible",
        description:
          "The tool allows users to create live visualization with the saved graphs. \nAlternatively, you can create a totally unique visualization based on your \nspecific business needs.",
        featureImage: feature1,
        imagePosition: "right",
      },
      {
        title: "Supercharge numbers into \ninsights",
        description:
          "The tool facilitates transformation of raw data into  easy-to-understand \nvisualizations to make data-driven decisions. ",
        featureImage: feature2,
        imagePosition: "left",
      },
      {
        title: "Highly interactive dashboards",
        description:
          "The interactive dashboard allows granular level slice and dice \nof data to understand the impact of different scenarios.",
        featureImage: feature3,
        imagePosition: "right",
      },
    ],
    subSectionTitle: "Explore DashX",
    platformText:
      "Data driven decisions become easy with the instant view of KPIs",
  }
  const handleNumberSelect = value => {
    setDetails({ phone: value })
  }
  const getCountryCode = value => {
    let countryCode = value && getCountryCallingCode(value)
    setDetails({ country_code: `+${countryCode}` })
  }
  const onChange = e => {
    const { name, value } = e.target
    setDetails({ [name]: value })
  }
  const onCheck = e => {
    setDetails({ terms: e.target.checked })
  }
  const submit = async () => {
    setDetails({ submitted: true })
    const {
      name,
      phone,
      email,
      company,
      comments,
      designation,
      country_code,
      terms,
    } = details
    let data
    if (
      name !== "" &&
      phone !== "" &&
      email !== "" &&
      company !== "" &&
      comments !== "" &&
      designation !== "" &&
      validateEmail(email)
    ) {
      if (!terms) {
        alert("please accept our terms and conditions")
        return
      }
      let number = formatNumber(phone)
      data = {
        form_name: "contact form",
        page_url: pathname,
        section_name: "scoopx",
        name,
        company_name: company,
        designation,
        email,
        country_code,
        phone_number: number,
        your_message: comments,
      }
      try {
        setDetails({ requesting: true })
        let result = await requestService.productForm(data)
        setDetails({
          phone: "",
          name: "",
          email: "",
          company: "",
          comments: "",
          designation: "",
          country_code: "",
          requesting: false,
          terms: false,
          response: result && result.more_info,
          submitted: false,
        })
      } catch (err) {
        console.log(err)
        setDetails({ requesting: false })
      }
    }
  }
  return (
    <Layout withBrand slidePosition={0} btnBg="#F5A253" btnColor="#FFFFFF">
      {showSuccessModal && <SucessModal show={showSuccessModal} />}
      <SEO
        title="Wersel DashX"
        keywords="data visualization tools, best data visualization tools, business intelligence dashboard, big data visualization tools"
        description="Wersel’s AI and human intuition dashboard turns data into live visualizations and real-time metrics, instantly available on any device to power decision-making at every level across the organization."
        url="www.wersel.io/products/dashx"
      />
      <OurSolutions data={data} btnBg="#F5A253" btnColor="#FFFFFF" />
      <Features title="DashX Features" features={data.features} />
      <BookingSection
        howItWorksTitle="Tap into the future trends and facilitate insightful decision making"
        howItWorks="DashX gives you visibility on the core KPIs that are mission-critical to your business"
      />
      <Clients title="We gave solutions for" />
      <InquireSection
        withoutFaqText
        btnBg="#F5A253"
        btnColor="#FFFFFF"
        faq={productFaq}
        handleNumberSelect={handleNumberSelect}
        getCountryCode={getCountryCode}
        details={details}
        onChange={onChange}
        submit={submit}
        onCheck={onCheck}
      />
      {/* <TestimonialSection /> */}
      <OtherProducts path={pathname} title="Products" posts={otherProducts} />
    </Layout>
  )
}

export default DashX
